import * as blUrls from 'lib/urls'
import { CONFIG } from 'shared/constants'
import {
  DME_ZENDESK_URL,
  HEALTH_CONTACT_EMAIL,
  INSURANCE_PARTNER_PATH,
  PRIVACY_URL,
  TERMS_AND_CONDITIONS_PATH,
} from '../../constants'

export const FOOTER_NAV = [
  {
    heading: 'Guides',
    href: blUrls.babylistUrl(blUrls.helloBabyPath),
    links: [
      {
        href: blUrls.babylistUrl(blUrls.helloBabyPostPath('best-breast-pump')),
        name: 'Best Breast Pumps',
      },
      {
        href: blUrls.babylistUrl(blUrls.helloBabyPostPath('breast-pump-parts')),
        name: 'Babylist Gear Glossary: Breast Pumps',
      },
      {
        href: blUrls.babylistUrl(
          blUrls.helloBabyPostPath('breast-pumps-for-every-budget')
        ),
        name: 'Best Breast Pump for Every Budget',
      },
      {
        href: blUrls.babylistUrl(
          blUrls.helloBabyPostPath('best-wearable-breast-pumps')
        ),
        name: 'Best Wearable Breast Pumps',
      },
      {
        href: blUrls.babylistUrl(
          blUrls.helloBabyPostPath('how-to-pump-breast-milk')
        ),
        name: 'How To Pump Breast Milk',
      },
    ],
  },
  {
    heading: 'Support',
    href: DME_ZENDESK_URL,
    links: [
      {
        href: DME_ZENDESK_URL,
        name: 'Help Center',
      },
      {
        href: `mailto:${HEALTH_CONTACT_EMAIL}`,
        name: 'Contact Us',
      },
    ],
  },
  {
    heading: 'Registry',
    href: blUrls.babylistUrl(blUrls.howToCreateABabyRegistryPath),
    links: [
      {
        name: 'Why Babylist',
        href: blUrls.babylistUrl(blUrls.whyBabyListPath),
      },
      { name: 'Find Registry', href: blUrls.babylistUrl(blUrls.findPath) },
      {
        name: 'Create Registry',
        href: blUrls.babylistUrl(blUrls.newRegistryPath),
      },
      {
        name: 'Baby Registry Checklist',
        href: blUrls.babylistUrl(blUrls.checklistPath),
      },
      {
        name: `${CONFIG.store.registryDiscountPctDisplay} Registry Discount`,
        href: blUrls.babylistUrl(blUrls.registryDiscountPath),
      },
    ],
  },
  {
    heading: 'About Us',
    href: INSURANCE_PARTNER_PATH,
    links: [
      { name: 'Our Story', href: blUrls.babylistUrl(blUrls.aboutPath) },
      {
        name: 'Babylist Health Advisory Board',
        href: blUrls.babylistUrl(blUrls.healthAdvisoryBoardPath),
      },
      { name: 'Terms of Use', href: TERMS_AND_CONDITIONS_PATH },
      { name: 'Privacy Policy', href: PRIVACY_URL, target: '_blank' },
      { name: 'Cookie Notice', href: blUrls.babylistUrl(blUrls.cookiesPath) },
      { name: 'CCPA Notice', href: blUrls.babylistUrl(blUrls.ccpaPath) },
      { name: 'Sitemap', href: blUrls.babylistUrl(blUrls.seoSitemapPath) },
    ],
  },
]
